import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { Props } from '@wix/da-shared-react/pkg/Duperbrowse/DeviationDuperbrowseContext';
import { AppState } from '../../../types/store';
import { getBiExtraData } from '../../selectors/biLogger';

type Parent = NonNullable<Props['parent']>;
type ParentWithoutBI = Pick<Parent, Exclude<keyof Parent, 'typeId' | 'itemId'>>;

export type StateProps = Pick<Props, 'parent'>;
export type OwnProps = Pick<Props, Exclude<keyof Props, keyof StateProps>> & {
  parent: ParentWithoutBI;
};

const mapStateToProps = (state: AppState, { parent }: OwnProps): StateProps => {
  const { typeid, itemid } = getBiExtraData(state);
  return {
    parent: {
      ...parent,
      typeId: typeid,
      itemId: itemid,
    },
  };
};

export default connect(mapStateToProps) as (
  component: ComponentType<Props>
) => ComponentType<OwnProps>;
